import { MARQUEE_ITEMS } from '../data/content';

export const Marquee = () => (
  <div data-testid="editorial-marquee-container" className="relative overflow-hidden border-y border-gold/20 bg-espresso py-6">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {MARQUEE_ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-serif text-2xl font-light italic text-cream/90 md:text-4xl">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
